<template>
  <div class="question-list-component">
    <div class="question-title">{{ title }}</div>
    <div class="question-list">
      <div class="question-item"
           :class="{'active': item.showAnswer}"
           v-for="(item, index) in list"
           :key="index"
           @click="handleShowAnswer(index, item.showAnswer)"
      >
        <div class="question">Q{{ index + 1 }}.{{ item.question }}</div>
        <ym-content class="answer"
                    :content="item.answer"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Content from '@/components/RichText';

  export default {
    name: 'QuestionList',
    components: {
      'ym-content': Content,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      list: {
        type: Array,
        required: true,
      },
    },
    methods: {
      handleShowAnswer(index, showAnswer) {
        if (showAnswer) {
          this.list[index].showAnswer = false;
          return;
        }
        this.list.map((item) => {
          item.showAnswer = false;
          return item;
        });
        this.list[index].showAnswer = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .question-list-component {
    background: @color-white;
    padding-bottom: @size-base;
  }

  .question-title {
    padding: @size-base;
    color: @color-text-base;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    border-bottom: @border-base;
  }

  .question-item {
    color: @color-text-light;
    font-size: @font-size-base;
    padding: @size-base;
    position: relative;
    &:after {
      position: absolute;
      content: '';
      background: @background-color-base;
      width: 690px;
      height: 1px;
      left: 30px;
      bottom: 0;
    }
    &.active {
      padding: @size-medium @size-base;
      .question {
        color: @color-text-primary;
        font-weight: @font-weight-primary;
        margin-bottom: @size-small;
      }
      .answer {
        display: block;
      }
    }
  }

  .question {
    color: @color-text-base;
    font-weight: @font-weight-primary;
  }

  .answer {
    display: none;
    /deep/ p {
      margin: 0;
      line-height: 1.6;
      &:not(:last-child) {
        margin-bottom: @size-small;
      }
    }
  }
</style>
